// document.addEventListener('DOMContentLoaded', function() {
//     var chatButton = document.getElementById('casinokart-whatsapp-chat-button');
//     if (chatButton) {
//         chatButton.style.position = 'fixed'; // Ensure the element is positioned
//         chatButton.style.bottom = '16px';   // Adjust as needed
//         chatButton.style.right = '16px';    // Adjust as needed
//         chatButton.style.zIndex = '9999';   // High z-index to appear on top
//     }
// });


document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("toggleButton");
  const textContainer = document.querySelector(".section-blocks__text.ff-body.rte.fs-body-75");

  toggleButton.addEventListener("click", function () {
    textContainer.classList.toggle("expanded");
    toggleButton.textContent = textContainer.classList.contains("expanded") ? "Show Less -" : "Show More +";
  });
});


